export const RESET_PWD = 'RESET_PWD';
export const RESET_PWD_SUCCESS = 'RESET_PWD_SUCCESS';
export const RESET_PWD_ERROR = 'RESET_PWD_ERROR';
